import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['terms'];

  toggle(event) {
    this.termsTarget.classList.toggle('hide', !event.target.checked);
  }
}
